<template>
  <div class="func-search-recommend-link">
      <span>
        <p class="text-center">
        <a 
        v-on:click="clickLink()" 
        class="btn btn-info btn-lg btn-download"
        role="button">
            <slot></slot>
          </a>
          </p>
      </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'FuncSearchRecommendLinkBtn',
  props: {
    fcontId: String,
    howto: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(['setupnavi', 'languageChangeCount', 'lg2']),
    ...mapState('articles', ['articles'])
  },
  methods: {
    clickLink: function() {
      // GA4
      {
        this.$gtag.event("tap_button", {
          "custom_parameter1": "article_link",
          "custom_parameter2": this.fcontId
        })
      }
      
      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/' + this.fcontId,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    },
    isExist: function () {
      const test = this.articles.find((article) => this.fcontId == article.id);
      return test !== undefined;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-info {
    color: #fff;
    background-color: #5bc0de;
    border-color: #46b8da;
}
</style>
